import styled from "@emotion/styled"
import HeroCaseItemLink from "components/HeroCase/HeroCaseItemLink"

const HeroScrollCaseItemLink = styled(HeroCaseItemLink)`
  margin-bottom: 4px;
  font-weight: 500;
`

export default HeroScrollCaseItemLink
